import React from 'react';
import { Undo2 } from 'lucide-react';
import { ToneBadge } from '../../../components/ui/ToneBadge';
import { OPERATOR_FLOW } from '../../../features/operator/operatorConstants';
import { TASK_TYPE, TASK_TYPE_LABELS } from '../../../features/operatorTasks/operatorTasksUtils';
import { OPERATOR_FLOW_ICONS } from '../operatorNavigation';

const ICONS = {
  [TASK_TYPE.PICK]: OPERATOR_FLOW_ICONS[OPERATOR_FLOW.PICKING],
  [TASK_TYPE.PACK]: OPERATOR_FLOW_ICONS[OPERATOR_FLOW.PACKING],
  [TASK_TYPE.RECEIVE]: OPERATOR_FLOW_ICONS[OPERATOR_FLOW.RECEIVING],
  [TASK_TYPE.PUTAWAY]: OPERATOR_FLOW_ICONS[OPERATOR_FLOW.PUTAWAY],
  [TASK_TYPE.RESTOCK]: Undo2,
  [TASK_TYPE.SHIP]: OPERATOR_FLOW_ICONS[OPERATOR_FLOW.DISPATCH],
};

/**
 * What kind of task it is, with the icon of its flow.
 *
 * @param {object} props
 * @param {string} props.type
 */
export const TaskTypeChip = ({ type }) => (
  <ToneBadge tone="info" icon={ICONS[type]} testId="task-type-chip">
    {TASK_TYPE_LABELS[type] || type}
  </ToneBadge>
);
